import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";

import loadEmpty from "assets/images/load-empty.png";
import { routes } from "constants/routes";
import { usePullToRefresh } from "context/PullToRefreshContext";
import LoadPostedItem from "features/main/Loads/modules/LoadPostedItem/LoadPostedItem";
import LoadPostedItemSkeleton from "features/main/Loads/modules/LoadPostedItem/LoadPostedItemSkeleton";
import { convertSavedLoadData } from "helpers/convertFormData";
import { showErrorMessage } from "helpers/toastMessage";
import { QUERY_SAVED_LOAD_LIST } from "./query";
import styles from "./style.module.scss";

export default function SavedLoads() {
  const navigate = useNavigate();

  //graphQL
  const { data, loading, error, refetch } = useQuery(QUERY_SAVED_LOAD_LIST, {
    fetchPolicy: "cache-and-network"
  });
  usePullToRefresh(refetch);

  useEffect(() => {
    if (!loading && error) {
      showErrorMessage(error.message);
    }
  }, [loading]);

  const savedLoadList = useMemo(
    () => (data ? convertSavedLoadData(data.userSavedLoads) : []),
    [data]
  );

  function goDetails(id: string) {
    navigate(`${routes.LOADS_SEARCH}/${id}`);
  }

  return (
    <div className={styles.savedLoadsList}>
      {loading && savedLoadList.length === 0 ? (
        [...Array(3)].map((_, index) => <LoadPostedItemSkeleton key={index} />)
      ) : savedLoadList.length > 0 ? (
        savedLoadList.map((item) => (
          <LoadPostedItem
            key={item.id}
            data={item}
            refresh={refetch}
            onClickDetails={() => goDetails(item.id)}
            isSavedLoad
          />
        ))
      ) : (
        <div className={styles.savedLoadEmptyList}>
          <img src={loadEmpty} alt="Empty saved load" />
          <h3 className={styles.savedLoadEmptyTitle}>No results found.</h3>
        </div>
      )}
    </div>
  );
}
